export const endpoints = {
  businessGroup: {
    all: '/businessGroup',
    byId: '/businessGroup/detail/:id',
    create: '/businessGroup/create',
    update: '/businessGroup/update/:id',
  },
  surrenders: {
    state: '/rendiciones/estados',
    byIdStateAndDate: '/rendiciones/getforoperaciones?IdEstadoRendicion=:IdEstadoRendicion&FechaInicio=:FechaInicio&FechaFin=:FechaFin',
    byIdStateAndDateV2: '/rendiciones/getforoperacionesv2?IdEstadoRendicion=:IdEstadoRendicion&FechaInicio=:FechaInicio&FechaFin=:FechaFin',
    validateDuplicateDocument: '/rendiciones/validardocumentorduplicado/:idRendicion',
    confirmSurrender: '/rendiciones/confirmar/:idRendicion',
    deleteSurrender: '/rendiciones/:idRendicion',
    getByIdRendicion:'/rendiciones/:idRendicion',
    surrendersExcel: '/rendiciones/getforoperacionesexcel?IdEstadoRendicion=:IdEstadoRendicion&FechaInicio=:FechaInicio&FechaFin=:FechaFin',
    showAdvance: '/rendiciones/mostraranticipo/:idPerfil',
    checkRechazoParcial: '/rendiciones/checkrechazoparcial',
  },
  items: {
    allItemByIdRendicion: '/items/getitemsbyrendicion/:idRendicion',
    deleteItem: '/items/:idItem',
    byIdItem: '/items/:idItem',
    create: '/items',
    update: '/items/:idItem',
    downloadFile: '/items/downloadcomprobante/:idItem',
    observarItem: '/items/observar',
    revertirItemObservado: '/items/revertirobservacion/:idItem',
    rechazarItemObservados: '/items/rechazaritemsContabilidad/:idRendicion',
    regenerarReporteItem: '/items/reportgenerate/:idItem',
  },
  maestros: {
    tipoDocumento: '/maestros/tipodocumento',
    tipoGasto: '/maestros/tipogasto',
    categoriaGasto: '/maestros/categoriagasto/:tipoGasto',
    igv: '/maestros/igv',
    tipoTransaccion: '/maestros/tipotransaccion'
  },
  accounts: {
    centroCostos: '/accounts/centrocostos'
  },
  proveedor: {
    byRuc: '/proveedores/validate/:ruc',
    star: '/proveedores/getfavorites/:userName',
    marcarFavorito: '/proveedores/addfavorite',
    eliminarFavorito: '/proveedores/deletefavorite'
  },
  surrendersCaja: {
    allSurrenders: '/rendiciones/getforcaja?Codigo=:Codigo&IdEstadoRendicion=:IdEstadoRendicion&NombreEmpleado=:NombreEmpleado&DNIEmpleado=:DNIEmpleado&CentroCosto=:CentroCosto&FechaInicioConfirmacion=:FechaInicioConfirmacion&FechaFinConfirmacion=:FechaFinConfirmacion&FechaInicioAprobacion=:FechaInicioAprobacion&FechaFinAprobacion=:FechaFinAprobacion',
    allSurrendersV2: '/rendiciones/getforcajav2?Codigo=:Codigo&IdEstadoRendicion=:IdEstadoRendicion&NombreEmpleado=:NombreEmpleado&DNIEmpleado=:DNIEmpleado&CentroCosto=:CentroCosto&FechaInicioConfirmacion=:FechaInicioConfirmacion&FechaFinConfirmacion=:FechaFinConfirmacion&FechaInicioAprobacion=:FechaInicioAprobacion&FechaFinAprobacion=:FechaFinAprobacion',
    getSurrenderInfo: '/rendiciones/info/:idRendicion',
    massApprove: '/rendiciones/aprobarmasivoporcaja',
    massApproveV2: '/rendiciones/aprobarmasivoporcajav2',
    updateItemCaja: '/items/updateitemcaja/:idItem',
    deleteItemCaja: '/items/deleteitemcaja',
    approveSurrenderCaja: '/rendiciones/aprobarporcaja',
    approveSurrenderCajaV2: '/rendiciones/aprobarporcajav2',
    declineSurrenderCaja: '/rendiciones/rechazarporcaja',
    massDecline: '/rendiciones/rechazarmasivoporcaja',
    surrendersCajaExcel: '/rendiciones/getforcajaexcel?Codigo=:Codigo&IdEstadoRendicion=:IdEstadoRendicion&NombreEmpleado=:NombreEmpleado&DNIEmpleado=:DNIEmpleado&CentroCosto=:CentroCosto&FechaInicioConfirmacion=:FechaInicioConfirmacion&FechaFinConfirmacion=:FechaFinConfirmacion&FechaInicioAprobacion=:FechaInicioAprobacion&FechaFinAprobacion=:FechaFinAprobacion',
    adelantoCajaDownload:'/movimientocaja/Adelanto/:idItem',
    devolucionCajaDownload:'/movimientocaja/devolucion/:idItem'

  },
  surrendersCentroCosto: {
    allSurrenders: '/rendiciones/getforresponsablececo/?Codigo=:Codigo&IdEstadoRendicion=:IdEstadoRendicion&NombreEmpleado=:NombreEmpleado&DNIEmpleado=:DNIEmpleado&CentroCosto=:CentroCosto&FechaInicioConfirmacion=:FechaInicioConfirmacion&FechaFinConfirmacion=:FechaFinConfirmacion&FechaInicioAprobacion=:FechaInicioAprobacion&FechaFinAprobacion=:FechaFinAprobacion',
    allSurrendersV2: '/rendiciones/getforresponsablececov2/?Codigo=:Codigo&IdEstadoRendicion=:IdEstadoRendicion&NombreEmpleado=:NombreEmpleado&DNIEmpleado=:DNIEmpleado&CentroCosto=:CentroCosto&FechaInicioConfirmacion=:FechaInicioConfirmacion&FechaFinConfirmacion=:FechaFinConfirmacion&FechaInicioAprobacion=:FechaInicioAprobacion&FechaFinAprobacion=:FechaFinAprobacion',
    approveSurrenderCeCo: '/rendiciones/aprobarporceco/:idRendicion',
    approveSurrenderCeCoV2: '/rendiciones/aprobarporcecov2/:idRendicion',
    declineSurrenderCeCo: '/rendiciones/rechazarporceco',
    massApprove: '/rendiciones/aprobarmasivoporceco',
    massApproveV2: '/rendiciones/aprobarmasivoporcecov2',
    massDecline: '/rendiciones/rechazarmasivoporceco',
    surrendersCeCoExcel: '/rendiciones/getforcecoexcel?Codigo=:Codigo&IdEstadoRendicion=:IdEstadoRendicion&NombreEmpleado=:NombreEmpleado&DNIEmpleado=:DNIEmpleado&CentroCosto=:CentroCosto&FechaInicioConfirmacion=:FechaInicioConfirmacion&FechaFinConfirmacion=:FechaFinConfirmacion&FechaInicioAprobacion=:FechaInicioAprobacion&FechaFinAprobacion=:FechaFinAprobacion'
  },
  surrendersContabilidad: {
    allSurrenders: '/rendiciones/getforresponsablecontabilidad?',
    allSurrendersV2: '/rendiciones/getforresponsablecontabilidadv2?',
    approveSurrender: '/rendiciones/aprobarporcontabilidad',
    declineSurrender: '/rendiciones/rechazarporcontabilidad',
    massApprove: '/rendiciones/aprobarmasivoporcontabilidad',
    massDecline: '/rendiciones/rechazarmasivoporcontabilidad',
    itemsForRendicion: '/items/getitemsforcontabilidad/:idRendicion',
    registerAdvance: '/rendiciones/registraranticipo',
    itemsDownloadExcel: '/items/getitemsforcontabilidadexcel/:idRendicion',
    surrendersContabilidadExcel: '/rendiciones/getforcontabilidadexcel?',
    setCutSurrenders: '/rendiciones/crearcorte',
    cutReport: '/rendiciones/reporteCorte',
  },
  masterData: {
    allMasters: '/maestros',
    masterDetails: '/maestros/detalles/:codigoMaestro',
    create: '/maestros/detalles',
    update: '/maestros/detalles',
    delete: '/maestros/detalles',
    disabled: '/maestros/detalles/disable'
  },
  collaborators: {
    allCollaborators: '/empleado',    
    posts: '/Empleado/ListarPuestosPorDivision/:idDivision',
    create: '/Empleado',
    update: '/Empleado',
    delete: '/Empleado/:idEmpleado',
    collaboratorsForCash: '/Empleado/ListarPorCaja/:codigoCaja',
    getBankAccount: '/Empleado/ObtenerCuenta/Usuario/:userName',
    listBanks: '/Empleado/ListarBancos',
    updateBankAccount: '/Empleado/ActualizarCuenta',
    getCollaboratorById: '/Empleado/:id',
    updateFirma: '/Empleado/ActualizarFirma',
    getAllCollaboratorsByIdDivision: '/Empleado/ListarEmpleadoPorDivision/:idDivision',
    getAllSupervisors: '/Empleado/ListarSupervisores',
    getAllPuestoByIdDivision: '/Empleado/ListarPuestosPorDivision/:idDivision',   

  },
  otherSecurity: {
    typeDocument: '/Maestro/TipoDocumento',
    division: '/Division',
  },
  collaboratorsCeCo: {
    allDivisionEmployee: '/CentroCosto/Listar/Division/:idDivision/Empleado/:idEmpleado',
    registerCeCos: '/CentroCosto/RegistrarPorEmpleado/:idEmpleado'
  },
  configurations: {
    allConfigurations: '/configuracion',
    update: '/configuracion/:CodigoConfiguracion'
  },
  userSecurity: {
    allProfileUser: '/Usuario/ListarPerfil/Aplicacion/:idAplicacion/Usuario/:usuario',
    registerProfiles: '/Usuario/RegistrarPerfiles/Usuario/:idUsuario',
    generateUser: '/Usuario/Generar/:idEmpleado',
    restorePassword: '/Usuario/ResetearContrasena/:userName',
    disableUser: '/Usuario/Desactivar/:idUsuario',
    changePassword: '/Usuario/CambiarContrasena',
    forgotPassword: '/Usuario/LinkReseteo',
    resetearContrasenaByLink: '/Usuario/ResetearContrasena',
  },
  collaboratorsExcel: {
    downloadFormat: '/Empleado/DescargarFormatoColaboradores',
    upload: '/Empleado/RegistrarMasivo',
    downloadReport: '/Empleado/DescargarReporteColaboradores'
  },
  movementCash: {
    allCash: '/movimientocaja/getresponsablecaja',
    allOpenCash: '/movimientocaja/getforaperturacaja?CodigoCaja=:codigoCaja&FechaOperacionInicio=:fechaOperacionInicio&FechaOperacionFin=:fechaOperacionFin',
    createNewEntry: '/movimientocaja/createaperturacaja',
    allOpenCashExcel: '/movimientocaja/getforaperturacajaexcel?CodigoCaja=:codigoCaja&FechaOperacionInicio=:fechaOperacionInicio&FechaOperacionFin=:fechaOperacionFin',
    allAdvances: '/movimientocaja/getforadelantocaja?CodigoCaja=:codigoCaja&Usuario=:usuario&Estado=:estado&FechaOperacionInicio=:fechaOperacionInicio&FechaOperacionFin=:fechaOperacionFin',
    createNewAdvance: '/movimientocaja/crearadelanto',
    allAdvancesExcel: '/movimientocaja/getforadelantoexcel?CodigoCaja=:codigoCaja&Usuario=:usuario&Estado=:estado&FechaOperacionInicio=:fechaOperacionInicio&FechaOperacionFin=:fechaOperacionFin',
    allRefounds: '/movimientocaja/getfordevolucioncaja?CodigoCaja=:codigoCaja&Usuario=:usuario&Estado=:estado&FechaOperacionInicio=:fechaOperacionInicio&FechaOperacionFin=:fechaOperacionFin',
    allRefoundsExcel: '/movimientocaja/getfordevolucionexcel?CodigoCaja=:codigoCaja&Usuario=:usuario&Estado=:estado&FechaOperacionInicio=:fechaOperacionInicio&FechaOperacionFin=:fechaOperacionFin',
    approveRefound: '/movimientocaja/aprobardevolucion/:idMovimientoCaja',
    declineRefound: '/movimientocaja/rechazardevolucion/:idMovimientoCaja',
    massApproveRefounds: '/movimientocaja/aprobarmasivodevoluciones',
    massDeclineRefounds: '/movimientocaja/rechazarmasivodevoluciones',
    approveAdvance: '/movimientocaja/aprobaradelanto',
    declineAdvance: '/movimientocaja/rechazaradelanto/:idMovimientoCaja',
    massApproveAdvances: '/movimientocaja/aprobarmasivoadelantos',
    massDeclineAdvances: '/movimientocaja/rechazarmasivoadelantos',
    getCollaboratorsBalance: '/movimientocaja/getcolaboradorforarqueo?CodigoCaja=:codigoCaja&Usuario=:usuario',
    createNewRefound: '/movimientocaja/creardevolucion',
    createPayment: '/movimientocaja/crearpagocolaborador',
    paymentsTreasuryCash: '/movimientocaja/getreembolsoforarqueo?CodigoCaja=:codigoCaja&Usuario=:usuario&FechaInicio=:FechaInicio&FechaFin=:FechaFin',
    paymentsCash: '/movimientocaja/getforreembolsos?CodigoCaja=:codigoCaja&Estado=:estado&FechaOperacionInicio=:fechaOperacionInicio&FechaOperacionFin=:fechaOperacionFin',
    downloadFormat: '/movimientocaja/descargarformatoreembolso',
    uploadPayments: '/movimientocaja/registrarreembolsomasivo',
    viewMovementCollaborator: '/movimientocaja/getmovimientoscolaboradorforarqueo?CodigoCaja=:codigoCaja&Usuario=:usuario',
    getCollaboratorsBalanceExcel: '/movimientocaja/getcolaboradorforarqueoexcel?CodigoCaja=:codigoCaja&Usuario=:usuario',
    paymentsTreasuryCashExcel: '/movimientocaja/getreembolsoforarqueoexcel/:idMovimientoCaja',
    saldoForCashBalance: '/movimientocaja/getsaldocajaforarqueo/:codigoCaja',
    reportConsolidated:'/movimientocaja/getreembolsoexcelconsolidado?CodigoCaja=:codigoCaja&Usuario=:usuario'
  },
  centroCosto: {
    allCentroCostoByUser: '/centrocosto/ListarAsignado/Empleado/:idEmpleado',
    allCentroCostoByDivision: '/CentroCosto/Listar/Division/:idDivision',
    createCostCenter: '/CentroCosto',
    updateCostCenter: '/CentroCosto',
    deleteCostCenter: '/CentroCosto/:idCentroCosto',
  },
  division:{
    getAllDivision:'/Division',
    createDivision: '/Division',
    updateDivision: '/Division',
    deleteDivision: '/Division/:idDivision',
  },
  vehicle:{
    getFilterVehicle: '/Vehiculo?IdDivision=:idDivision&IdCentroCosto=:idCentroCosto&Placa=:Placa',
    getTypeVehicle: '/Vehiculo/Tipo',
    getDocumentEvidenceVehicle: '/Vehiculo/Evidencia?IdTipoVehiculo=:idTipoVehiculo&IdVehiculo=:idVehiculo',
    getDownloadDocument: '/Vehiculo/Documento/Evidencia/:idVehiculoDocumentoEvidencia',
    createVehicle: '/Vehiculo',
    updateVehicle: '/Vehiculo',
    deleteVehicle: '/Vehiculo/:idVehiculo',
    getVehicleById: '/Vehiculo/:idVehiculo',
    createEvidence: '/Vehiculo/Evidencia',
    updateEvidence: '/Vehiculo/Evidencia',
    getAllVehicleByIdDivision: '/Vehiculo/ListarVehiculoPorDivision/:idDivision',
    getDownloadDocumentMassive: '/vehiculo/FormatoMasivo',
    getDownloadReport: '/vehiculo/Reporte?IdDivision=:idDivision&IdCentroCosto=:idCentroCosto&Placa=:Placa',
    addMassive: '/Vehiculo/Masivo',
    activateVehicle: '/Vehiculo/Activar/:idVehiculo',
    deactivateVehicle: '/Vehiculo/Desactivar/:idVehiculo'
  },
  crews:{
    getFilterCrews: '/cuadrillas?IdDivision=:IdDivision&NombreIntegrante=:NombreIntegrante&NumeroIntegrantes=:NumeroIntegrantes',
    getTipeCrews: '/cuadrillas/Tipo',
    getDocumentEvidenceCrews: '/cuadrillas/Evidencia?IdTipoVehiculo=:idTipoVehiculo&IdVehiculo=:idVehiculo',
    createCrews: '/cuadrillas',
    updateCrews: '/cuadrillas/:idCuadrilla',
    deleteCrews: '/cuadrillas/:idCuadrilla',
    getCrewsById: '/cuadrillas/:idCuadrilla',
    disabledCrews: '/cuadrillas/deactivate/:idCuadrilla',
    getDownloadDocumentMassive: '/cuadrillas/format',
    getDownloadReport: '/cuadrillas/report?IdDivision=:IdDivision&NombreIntegrante=:NombreIntegrante&NumeroIntegrantes=:NumeroIntegrantes',
    addMassive: '/cuadrillas/massive'
  },
  shift:{
    getShiftByIdDivision: '/turnos?IdDivision=:idDivision',
    createShift: '/turnos',
    updateShift: '/turnos/:idTurno',
    deleteShift: '/turnos/:idTurno',
    getShiftById: '/turnos/:idTurno',
  },
  vehicleType:{
    getTypeVehicle: '/Vehiculo/Tipo',    
    getVehicleTypeById: '/Vehiculo/Tipo/:idTipoVehiculo',
    createVehicleType: '/Vehiculo/Tipo',
    updateVehicleType: '/Vehiculo/Tipo',
    deleteVehicleType: '/Vehiculo/Tipo/:idTipoVehiculo',
  },
  documentVehicle:{
    getdocumentVehicleByIdTipoVehiculo: '/TipoVehiculoDocumento?idTipoVehiculo=:idTipoVehiculo',    
    getdocumentVehicleById: '/TipoVehiculoDocumento/:idTipoVehiculoDocumento',
    createdocumentVehicle: '/TipoVehiculoDocumento',
    updatedocumentVehicle: '/TipoVehiculoDocumento',
    deletedocumentVehicle: '/TipoVehiculoDocumento/:idTipoVehiculoDocumento',
  },
  followVehicle:{
    getAllFollowVehicle: '/Vehiculo/Campo',

  },
  followTasks:{
    getAllFollowTasks: '/Empleado/Campo',

  },
  tasks:{
    getFilterTasks: '/tareos/integrantes?IdDivision=:idDivision&FechaInicio=:fechaInicio&FechaFin=:fechaFin',
    getDownloadReportTaks: '/tareos/report?IdDivision=:idDivision&FechaInicio=:fechaInicio&FechaFin=:fechaFin',
    setCutOffTasks: '/tareos/cutoff'
  },
  checkList:{
    getAllFilterCheckList: '/Vehiculo/Ejecucion?IdDivision=:idDivision&IdChecklist=:idChecklist&TipoVehiculo=:tipoVehiculo&Placa=:placa&UsuarioRegistro=:usuarioRegistro',
    getAllCheckList: '/Vehiculo/Checklist',
    getDownloadReportCheckList: '/Vehiculo/Ejecucion/Excel',
    getDocumentPdfCheckList: '/Ejecucion/PDF/:IdEjecucion',
  }
}
